import { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { buildPreviewHtml } from '../utils/emailPreviewBuilder';

const EmailPreview = ({ template }) => {
    const iframeRef = useRef(null);

    useEffect(() => {
        if (!iframeRef.current || !template) return;

        const html = buildPreviewHtml(template);
        const iframe = iframeRef.current;
        iframe.srcdoc = html;
    }, [template]);

    if (!template) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#999' }}>
                <Typography>Select a template to preview</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle2" sx={{ mb: 1, color: '#666' }}>
                Live Preview
            </Typography>
            <Box sx={{ flex: 1, border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', bgcolor: '#fff' }}>
                <iframe
                    ref={iframeRef}
                    title="Email Preview"
                    style={{ width: '100%', height: '100%', border: 'none', minHeight: '600px' }}
                    sandbox="allow-same-origin"
                />
            </Box>
        </Box>
    );
};

export default EmailPreview;
